<template>
  <div class="share_product">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <div class="center_list_head_right">
            <el-input v-model="product_id" placeholder="请输入商品id" size="small"></el-input>
            <el-button size="small" @click="add_product">添加商品</el-button>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column label="商品名称" prop="title" align="center"></el-table-column>
        <el-table-column prop="item_no" label="货号" align="center"></el-table-column>
        <el-table-column prop="selling_price" label="价格" align="center"></el-table-column>
        <el-table-column prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column prop="brand" label="品牌" align="center"></el-table-column>
        <el-table-column prop="classification" label="分类" align="center"></el-table-column>
        <el-table-column width="120" label="操作" align="center" name="bianji">
          <template style="display:flex;padding:0;margin:0" slot-scope="scope">
            <button class="button1" @click="de_pucduct(scope.row.id)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager1" style>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="setPage"
          hide-on-single-page
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      product_id: "",
      role:true,
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      page: null,
      total: 0,
      tableData: [],
      dialogVisible: false
    };
  },
  created() {
    this.$store.state.topActiveId = 5;
    this.$store.state.leftTitle = "分享推荐";
    this.geting();
  },
  methods: {
    add_product() {
      this.axios
        .get(this.serve + "/admin/share_recommend_add", {
          params: {
            id: this.product_id,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.open(res.data.msg);
            this.geting();
          } else {
            this.open4(res.data.msg);
          }
        });
    },
    open4(msg) {
      //错误时返回的息状态
      this.$message.error(msg);
    },
    open(msg) {
      this.$message({
        //成功时 返回的状态
        message: msg,
        type: "success"
      });
    },

    de_pucduct(id) {
      this.axios
        .get(this.serve + "/admin/share_recommend_del", {
          params: {
            id,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.open(res.data.msg);
            if ((this.total - 1) / 15 == this.page - 1) {
              this.geting(this.page - 1);
            } else {
              this.geting(this.page);
            }
          } else {
            this.open4(res.data.msg);
          }
        });
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
    },

    geting(page) {
      this.axios
        .get(this.serve + "/admin/share_recommend_list", {
          params: {
            page,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.tableData = res.data.data.results;
            this.page = res.data.data.page;
            this.total = res.data.data.total;
          }else{
            if(res.data.msg == "无权访问")
            {
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
.share_product {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_right {
      display: flex;
      margin-right: 10px;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>